import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-huis-en-omgeving',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconHuisEnOmgeving {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M35.78 7.8a.984.984 0 0 1-1.47.06l-.36-.29v8.06c0 .55-.45 1-1 1l-12.09.02c-.55 0-1-.45-1-1v-7.9l-.33.34a.975.975 0 0 1-1.39-.11l-.05-.06a.97.97 0 0 1 .15-1.39l8-6.31c.36-.28.86-.29 1.22-.02l4.5 3.24V1.96c0-.54.44-.98.98-.98h.05c.54 0 .98.44.98.98v2.87c0 .15.07.29.18.39l1.53 1.24c.39.35.44.94.11 1.34Zm-6.83 1.86c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1h2c.55 0 1-.45 1-1zM6.99 13C3.14 13 0 16.12 0 19.95c0 .33.03.65.08.96 0 .06.02.12.03.18.03.17.06.33.1.49.85 4.05 4.38 9.88 5.99 12.01.4.53 1.2.53 1.6 0 1.6-2.14 5.13-7.96 5.99-12.01.04-.16.07-.32.1-.49 0-.06.02-.12.03-.18.04-.32.08-.64.08-.96C14 16.12 10.87 13 7.01 13Zm0 9.93c-1.66 0-3-1.34-3-2.99s1.34-2.99 3-2.99 3 1.34 3 2.99-1.34 2.99-3 2.99m8.92-3.9c.04.35.07.71.07 1.07 0 .3-.02.61-.06.93 8.41.2 14.82 2.96 18.6 5.13.67.38 1.49-.1 1.49-.87v-.03c0-.36-.18-.68-.49-.86-3.98-2.3-10.7-5.17-19.61-5.36Zm-.77 5.16c-.23.64-.5 1.28-.8 1.92 6.03.65 9.66 4.1 11.79 7.43.18.28.48.45.82.45.76 0 1.24-.84.83-1.48-2.32-3.63-6.24-7.44-12.64-8.33Z"/>
</svg>

    );
  }
}
